<div class="not-found">
    <h1>Page not found</h1>
    <div class="not-found-image my-2"></div>
    <p class="py-8">
        Oops! We couldn't find the page you're looking for. Please double-check that you've entered the correct portal
        URL and try again.
    </p>
</div>
